// extracted by mini-css-extract-plugin
module.exports = {"base":"SponsoredImageStep_base__3EG-c","HelperText":"SponsoredImageStep_HelperText__28qwp","Card":"SponsoredImageStep_Card__kYIKJ"};